import { render, staticRenderFns } from "./DiagnosticCardOperatorIcon.vue?vue&type=template&id=97c84464&scoped=true"
import script from "./DiagnosticCardOperatorIcon.vue?vue&type=script&lang=ts"
export * from "./DiagnosticCardOperatorIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c84464",
  null
  
)

export default component.exports